module.exports = __webpack_public_path__ + "assets/drag.c17d3af2.svg";